import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { PlanoAcaoSituacao } from "../models/plano-acao-situacao.model";

@Injectable()
export class IndicadoresPgAtividadeSituacaoService extends BaseService<PlanoAcaoSituacao>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getByIdListEdit(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-edit/' + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/pg/atividade-situacao';
  }

}